export const ConfirmEliminarModal = ({ onCancel, onConfirm }) => (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
    <div style={{ background: "white", borderRadius: 16, padding: 24, maxWidth: 320, width: "100%", textAlign: "center" }}>
      <p className="text-4xl mb-3">🗑️</p>
      <h3 className="font-bold text-gray-800 text-lg mb-2">¿Eliminar documento?</h3>
      <p className="text-gray-500 text-sm mb-4">Esta acción es permanente y no se puede deshacer. El registro se eliminará completamente de Supabase.</p>
      <div className="flex gap-3">
        <button onClick={onCancel} className="flex-1 bg-gray-100 text-gray-700 font-bold py-2 rounded-lg hover:bg-gray-200">Cancelar</button>
        <button onClick={onConfirm} className="flex-1 bg-red-500 text-white font-bold py-2 rounded-lg hover:bg-red-600">Sí, eliminar</button>
      </div>
    </div>
  </div>
);
